/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function() {
	
    // Remove empty P tags created by WP inside of Accordion and Orbit
    jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
			jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
			jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});

	jQuery('#testimonials_carousel').owlCarousel({
		loop:false,
		margin:45,
		nav:false,
		dots:true,
		autoplay:true,
		autoplayTimeout:15000,
		responsive:{
			0:{
				items:1
			},
			300:{
				items:1
			},
			600:{
				items:1
			},
			1024:{
				items:1
			},
			1200:{
				items:3
			},
			1440:{
				items:3
			}
		}
	});

	jQuery('#subdivisions-section_4-nearby-carousel').owlCarousel({
		loop:false,
		margin:45,
		nav:false,
		dots:true,
		autoplay:true,
		autoplayTimeout:15000,
		responsive:{
			0:{
				items:1
			},
			300:{
				items:1
			},
			600:{
				items:2
			},
			1024:{
				items:3
			},
			1200:{
				items:4
			},
			1440:{
				items:5
			}
		}
	});

	// jQuery Magnify
	var $zoom = jQuery('.zoom');
	$zoom.magnify();
	var enabled = true;
	jQuery('#zoom').click(function(){
		if(enabled)
		{
			enabled = false;
			$zoom.destroy();
			jQuery(this).html('<i class="fas fa-search-plus"></i> Enable Zoom');
		}
		else
		{
			enabled = true;
			$zoom.magnify();
			jQuery(this).html('<i class="fas fa-search-minus"></i> Disable Zoom');
		}
	});

	// reference for main items
	var singlePropertyCarousel = jQuery('#single-property-carousel');
	// reference for thumbnail items
	var singlePropertyThumbnailCarousel = jQuery('#single-property-carousel-thumbs');
	//transition time in ms
	var duration = 300;

	singlePropertyCarousel.owlCarousel({

		loop:false,
		margin:0,
		nav:false,
		dots:false,
		autoplay:true,
		autoplayTimeout:15000,

		responsive:{
			0:{
				items:1
			},
			300:{
				items:1
			},
			600:{
				items:1
			},
			900:{
				items:1
			},
			1200:{
				items:1
			},
			1440:{
				items:1
			}
		}
	}).on('changed.owl.carousel', function (e) {
		//On change of main item to trigger thumbnail item
		singlePropertyThumbnailCarousel.trigger('to.owl.carousel', [e.item.index, duration, true]);
		singlePropertyThumbnailCarousel.find('.current').removeClass('current');
		var index = e.item.index;
		var offset = jQuery(e.target).find('.active:first').prevAll('.cloned').length;
		singlePropertyThumbnailCarousel.find('.owl-item').eq(index-offset).addClass('current');
	});

	singlePropertyThumbnailCarousel.owlCarousel({

		loop:false,
		margin:24,
		nav:false,
		dots:false,
		autoplay:false,

		responsive:{
			0:{
				items:2
			},
			300:{
				items:2
			},
			600:{
				items:3
			},
			900:{
				items:4
			},
			1200:{
				items:4
			},
			1440:{
				items:4
			}
		}
	}).on('click', '.owl-item', function () {
		// On click of thumbnail items to trigger same main item
		singlePropertyCarousel.trigger('to.owl.carousel', [jQuery(this).index(), duration, true]);
		singlePropertyThumbnailCarousel.find('.current').removeClass('current');
		jQuery(this).addClass('current');

	}).on('changed.owl.carousel', function (e) {
		// On change of thumbnail item to trigger main item
		singlePropertyCarousel.trigger('to.owl.carousel', [e.item.index, duration, true]);
	});

	singlePropertyThumbnailCarousel.find('.owl-item').first().addClass('current');

	jQuery('#singlePropertyCarouselRight').click(function() {
		singlePropertyCarousel.trigger('next.owl.carousel');
	});
	jQuery('#singlePropertyCarouselLeft').click(function() {
		singlePropertyCarousel.trigger('prev.owl.carousel');
	});
});

/*function offsetCenter(map, latlng, offsetx, offsety)
{
	// latlng is the apparent centre-point
	// offsetx is the distance you want that point to move to the right, in pixels
	// offsety is the distance you want that point to move upwards, in pixels
	// offset can be negative
	// offsetx and offsety are both optional

	var scale = Math.pow(2, map.getZoom());

	var worldCoordinateCenter = map.getProjection().fromLatLngToPoint(latlng);
	var pixelOffset = new google.maps.Point((offsetx/scale) || 0,(offsety/scale) ||0);

	var worldCoordinateNewCenter = new google.maps.Point(
		worldCoordinateCenter.x - pixelOffset.x,
		worldCoordinateCenter.y + pixelOffset.y
	);

	var newCenter = map.getProjection().fromPointToLatLng(worldCoordinateNewCenter);

	return newCenter;
}*/